import { useMemo } from 'react';


import JoinWaitListButton from './JoinWaitListButton';
import LeaveWaitListButton from './LeaveWaitListButton';
import { FetchUsersWaitListQuery } from '@website/types/graphqlOperations';

type Props = {
  groupID: string;
  userID: string;
  waitList?: FetchUsersWaitListQuery['user']['waitList']['items'];
};

/**
 *
 * WaitListButton
 *
 * Show a button to join or leave a groups waiting list
 *
 */
export default function WaitListButton({ groupID, userID, waitList }: Props) {
  const isUserInWaitList = useMemo(() => {
    return !!waitList?.find((item) => item.group.id === groupID);
  }, [waitList, groupID]);

  if (isUserInWaitList) {
    return <LeaveWaitListButton groupID={groupID} userID={userID} />;
  }
  return <JoinWaitListButton groupID={groupID} userID={userID} />;
}
